import { connect } from 'react-redux';
import Information, {
  InformationProps,
} from '@/pages/CompanyReport/components/Information';
import { getInformationSelector } from '../redux/selectors';
import { getViewMode } from '@/redux/location/selectors';

interface ContainerProps {
  companyId?: string;
  sectionNumber: number;
}
const mapStateToProps = (state, ownProps: ContainerProps): InformationProps => {
  const information = getInformationSelector(state, ownProps);
  const viewMode = getViewMode(state);
  return {
    viewMode,
    url: information.url,
    mainHeader: information.mainHeader,
    city: information.city,
    state: information.state,
    zipCode: information.zipCode,
    country: information.country,
    companyId: information.companyId,
    snowflakeOverallRating: information.snowflakeOverallRating,
    snowflakeSentence: information.snowflakeSentence,
    countryISO: information.countryISO,
    description: information.description,
    companyName: information.companyName,
    companyShortName: information.companyShortName,
    yearFounded: information.yearFounded,
    addressLine1: information.addressLine1,
    addressLine2: information.addressLine2,
    tickerSymbol: information.tickerSymbol,
    sectionNumber: ownProps.sectionNumber,
    totalEmployees: information.totalEmployees,
    totalEmployeesMin: information.totalEmployeesMin,
    totalEmployeesMax: information.totalEmployeesMax,
    currencySymbol: information.currencySymbol,
    currencyISO: information.currencyISO,
    exchangeSymbol: information.exchangeSymbol,
    exchangeSymbolFiltered: information.exchangeSymbolFiltered,
    exchangeListing: information.exchangeListing,
    marketCapListing: information.marketCapListing,
    marketCapPrimary: information.marketCapPrimary,
    originalMarketCap: information.originalMarketCap,
    sharesOutstanding: information.sharesOutstanding,
    industryPrimaryName: information.industryPrimaryName,
    industryTertiaryName: information.industryTertiaryName,
    lastAnalysisUpdateISOString: information.lastAnalysisUpdateISOString,
    lastAnalysisUpdateFormattedUTC: information.lastAnalysisUpdateFormattedUTC,
    lastEODPriceUpdateFormattedUTC: information.lastEODPriceUpdateFormattedUTC,
    lastEstimatesConfirmationFormattedUTC:
      information.lastEstimatesConfirmationFormattedUTC,
    lastEarningsUpdateFormattedUTC: information.lastEarningsUpdateFormattedUTC,
    lastAnnualEarninsUpdateFormattedUTC:
      information.lastAnnualEarninsUpdateFormattedUTC,
    skipDefer: information.skipDefer,
  };
};
export default connect<InformationProps, undefined, ContainerProps>(
  mapStateToProps
)(Information);
